// todo(workflows): inline hook call?

import { useOrganizationPermissions } from 'sierra-client/hooks/use-permissions'

export const useAreCertificatesEnabled = (): boolean => {
  const orgPermissions = useOrganizationPermissions()
  return orgPermissions.has('MANAGE_CERTIFICATES')
}
